var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationalIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6174_186564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 4C12.9531 4 4 12.9531 4 24C4 35.0469 12.9531 44 24 44C35.0469 44 44 35.0469 44 24C44 12.9531 35.0469 4 24 4ZM24 41.5C14.3516 41.5 6.5 33.6484 6.5 24C6.5 14.3516 14.3516 6.5 24 6.5C33.6484 6.5 41.5 14.3516 41.5 24C41.5 33.6484 33.6484 41.5 24 41.5ZM24 18.375C25.0352 18.375 25.875 17.5359 25.875 16.5C25.875 15.4648 25.0352 14.625 24 14.625C22.9648 14.625 22.125 15.4609 22.125 16.5C22.125 17.5391 22.9609 18.375 24 18.375ZM27.75 31.5H25.25V22.75C25.25 22.0625 24.6875 21.5 24 21.5H21.5C20.8125 21.5 20.25 22.0625 20.25 22.75C20.25 23.4375 20.8125 24 21.5 24H22.75V31.5H20.25C19.5625 31.5 19 32.0625 19 32.75C19 33.4375 19.5625 34 20.25 34H27.75C28.4403 34 29 33.4403 29 32.75C29 32.0625 28.4375 31.5 27.75 31.5Z",
    fill: "#009BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6174_186564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationalIcon);
export default __webpack_public_path__ + "static/media/informational-icon.a9dad8878acc98bfae5274deb91bd9ea.svg";
export { ForwardRef as ReactComponent };